import styled from 'styled-components';

export const Container = styled.div`
  padding: 12px 16px;
  position: relative;

  width: 300px;

  color: ${({ theme }) => theme.colors.gray[600]};
  background: ${({ theme }) => theme.colors.gray[100]};

  box-shadow: ${({ theme }) => theme.shadow.default};
  border-radius: 16px;

  text-align: end;

  span {
    font-size: 14px;
    font-weight: 400;
  }
`;

export const CardIcon = styled.div`
  position: absolute;
  left: 16px;
  top: -16px;

  height: 56px;
  width: 56px;

  font-size: 32px;

  display: flex;
  justify-content: center;
  align-items: center;

  background: ${({ color }) => color};

  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12),
    0px 2px 4px rgba(0, 0, 0, 0.2);
  border-radius: 8px;

  color: ${({ theme }) => theme.colors.white};
`;

export const Grid = styled.div`
  p {
    font-weight: 400;
    font-size: 12px;
    line-height: 24px;
  }

  .cardValue {
    font-size: 24px;
    font-weight: 700;

    color: ${({ theme, color }) => color ?? theme.colors.gray[400]};

    margin-top: 8px;
  }

  .divider {
    margin: 20px 0 4px 0px;
  }

  .footer {
    text-align: start;

    font-size: 12px;
  }
`;
